var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c(_setup.SiteHeader,{ref:"searchBar",attrs:{"layout":"document"}}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c(_setup.ShareUrlDialog,{ref:"shareUrlDialog"}),_vm._v(" "),_c(_setup.Spinner,{directives:[{name:"show",rawName:"v-show",value:(_setup.loading),expression:"loading"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }